import React, { useEffect } from "react";
import toastr from "toastr";
import {
  Button,
  Grid,
  Typography,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Box,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@mui/material/Input";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GetAppIcon from "@mui/icons-material/GetApp";
import {
  makeDELETERequestOnUserServiceWithQueryParameter,
  makePOSTRequestOnUserService,
} from "../../Api/api";
import GenericDialog from "../Dialog/GenericDialog";
import Chip from "@mui/material/Chip";
import { IconButton, TextField } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import copy from "copy-to-clipboard";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles(() => ({
  paper: {
    width: 650,
    minWidth: 650,
    maxWidth: 650,
    margin: "0 auto",
    padding: "24px",
  },
}));

function PanCardDetailsModalContent({ panCardDetails }) {
  return (
    <>
      <TextField
        label="PAN Number"
        value={panCardDetails.pan_number}
        fullWidth
        variant="outlined"
        margin="normal"
        InputProps={{ readOnly: true }}
      />

      <TextField
        label="KYC Holder Name"
        value={panCardDetails.kyc_holder_name}
        fullWidth
        variant="outlined"
        margin="normal"
        InputProps={{ readOnly: true }}
      />

      <div style={{ marginBottom: "8px" }}>
        <Typography variant="subtitle1">
          KYC Status in Codes:
        </Typography>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "4px",
          }}
        >
          {panCardDetails?.kyc_status_in_codes?.map((status, index) => (
            <Chip
              key={index}
              label={status}
              variant="outlined"
              color="primary"
              style={{ margin: "4px" }}
            />
          ))}
        </div>
      </div>

      <TextField
        label="KYC Status Last Updated Date"
        value={panCardDetails.kyc_status_last_updated_date}
        fullWidth
        variant="outlined"
        margin="normal"
        InputProps={{ readOnly: true }}
      />

      <TextField
        label="KYC Creation Date"
        value={panCardDetails.kyc_creation_date}
        fullWidth
        variant="outlined"
        margin="normal"
        InputProps={{ readOnly: true }}
      />
    </>
  );
}

const PanCardInformationGrid = (props) => {
  const isNRI =
    props.accountType === "individual_non_resident";

  const initialState = {
    panCardNumber: props?.panCard?.uuid || "",
    name: props?.panCard?.name || "",
    fathersName: props?.panCard?.fathers_name || "",
    dateOfBirth: props?.panCard?.dob || "",
    image: props?.panCard?.image || "",
    kyc_doc_plaintext_password:
      props?.panCard?.kyc_doc_plaintext_password || "",
    response_date_time:
      props?.panCard?.pan_status_response?.response_date_time || "",
    pan_status_response:
      props?.panCard?.pan_status_response || {},
    type: props?.panCard?.type || "pan",
  };

  const [currentState, setCurrentState] =
    React.useState(initialState);

  const [selectedFile, setSelectedFile] = React.useState(null);

  const [createCond, setCreateCond] = React.useState(
    props.panCard
      ? Object.keys(props.panCard).length === 0
      : true
  );

  const [showDeleteModal, setShowDeleteModal] =
    React.useState(false);

  const [showPanDetailsDialog, setShowPanDetailsDialog] =
    React.useState(false);

  const [panCardDetails, setPanCardDetails] =
    React.useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setCurrentState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  function deletePanCard(event) {
    event.preventDefault();

    makeDELETERequestOnUserServiceWithQueryParameter(
      `/kyc/pan_card/delete/${props.currentUser.uuid}/`
    )
      .then((response) => {
        if (response?.status === 204) {
          toastr.success(
            "Deleted Pan card successfully !"
          );

          setCurrentState(initialState);
          setShowDeleteModal(false);
          setSelectedFile(null);
          setCreateCond(true);

          props.nullifyPanCard(event);
        }
      })
      .catch((error) => toastr.error(error));
  }

  const savePanCardDetails = (event) => {
    event.preventDefault();

    let stateToSave = { ...currentState };

    if (selectedFile) {
      stateToSave.image = selectedFile;
    }

    props.savePanCardDetails(event, stateToSave);
  };

  function handlePanStatusClick() {
    if (!createCond || currentState.panCardNumber) {
      makePOSTRequestOnUserService("/kyc/cvl_pancard/get/", {
        admin_name: JSON.parse(
          localStorage.getItem("loginUser")
        )?.name,
        user_id: props.currentUser.uuid,
      })
        .then((resp) => {
          if (resp.status === 200) {
            setPanCardDetails(resp.data);
            setShowPanDetailsDialog(true);
          }
        })
        .catch((error) => toastr.error(error));
    } else {
      toastr.warning(
        "Pan Card Record needs to be created first."
      );
    }
  }

  const addPanCardDetails = (event) => {
    event.preventDefault();

    let state = { ...currentState };
    state.image = selectedFile;

    props.addPanCardDetails(event, state);
  };

  function downloadFile(e, b64) {
    e.preventDefault();

    const cleanBase64 = b64
      .replace(/^data:image\/\w+;base64,/, "")
      .replace(/^data:application\/pdf;base64,/, "")
      .replace(/\s/g, "");

    const isPdf = cleanBase64.startsWith("JVBERi0");

    const mimeType = isPdf
      ? "application/pdf"
      : "image/png";

    const extension = isPdf ? "pdf" : "png";

    try {
      const byteCharacters = atob(cleanBase64);

      const byteNumbers = new Array(
        byteCharacters.length
      );

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] =
          byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {
        type: mimeType,
      });

      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;
      link.download = `pan_card.${extension}`;

      if (isPdf) {
        link.target = "_blank";
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(url), 100);
    } catch (err) {
      toastr.error("Error downloading file");
    }
  }

  function renderImageOrPDFButton() {
    if (!props.panCard?.image) return null;

    const isPdf =
      props.panCard.image.startsWith("JVBERi0");

    return (
      <Box
        sx={{
          width: "100%",
          minHeight: 380,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: isPdf
            ? "#f5f5f5"
            : "transparent",
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          p: 2,
        }}
      >
        {isPdf ? (
          <>
            <PictureAsPdfIcon
              sx={{
                fontSize: 100,
                color: "#d32f2f",
                mb: 2,
              }}
            />

            <Typography
              variant="body2"
              color="text.secondary"
            >
              PDF Document Uploaded
            </Typography>
          </>
        ) : (
          <img
            src={`data:image/png;base64,${props.panCard.image}`}
            alt="Pan Card"
            style={{
              maxWidth: "100%",
              maxHeight: "350px",
              objectFit: "contain",
            }}
          />
        )}

        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={<GetAppIcon />}
          onClick={(event) =>
            downloadFile(event, props.panCard.image)
          }
          style={{ marginTop: 16 }}
        >
          Download {isPdf ? "PDF" : "Image"}
        </Button>
      </Box>
    );
  }

  const isForm60 =
    isNRI && currentState.type === "form_60";

  return (
    <Grid
      container
      spacing={4}
      justifyContent="center"
      alignItems="flex-start"
      style={{ padding: "20px" }}
    >
      {/* Left Preview Panel */}
      <Grid item>
        <Box
          sx={{
            width: 420,
            minWidth: 420,
            maxWidth: 420,
            minHeight: 420,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 2,
            backgroundColor: "#fafafa",
          }}
        >
          {createCond ? (
            <Box width="100%" textAlign="center">
              {selectedFile ? (
                selectedFile.type === "application/pdf" ? (
                  <Box textAlign="center">
                    <PictureAsPdfIcon
                      sx={{
                        fontSize: 100,
                        color: "#d32f2f",
                      }}
                    />

                    <Typography
                      variant="body2"
                      sx={{ mt: 1 }}
                    >
                      {selectedFile.name}
                    </Typography>
                  </Box>
                ) : (
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "380px",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                )
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  Upload a PAN Card image or PDF
                  to preview it here
                </Typography>
              )}
            </Box>
          ) : (
            renderImageOrPDFButton()
          )}
        </Box>
      </Grid>

      {/* Right Form Panel */}
      <Grid item>
        <Paper
          style={{
            width: 650,
            minWidth: 650,
            maxWidth: 650,
            padding: "24px",
            borderRadius: "12px",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            style={{ fontWeight: 600 }}
          >
            Pan Card {isForm60 ? "(Form 60)" : ""}
          </Typography>

          {isNRI && createCond && (
            <Box mt={2} mb={2}>
              <FormLabel
                component="legend"
                style={{ fontWeight: "bold" }}
              >
                Select Document Type
              </FormLabel>

              <RadioGroup
                row
                name="type"
                value={currentState.type}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="pan"
                  control={<Radio color="primary" />}
                  label="PAN Card"
                />

                <FormControlLabel
                  value="form_60"
                  control={<Radio color="primary" />}
                  label="Form 60"
                />
              </RadioGroup>
            </Box>
          )}

          {!isForm60 && (
            <>
              <Box mb={2}>
                <TextField
                  label="Name on PAN"
                  name="name"
                  variant="outlined"
                  fullWidth
                  value={currentState.name}
                  onChange={handleChange}
                />
              </Box>

              <Box mb={2}>
                <TextField
                  label="PAN Card Number"
                  name="panCardNumber"
                  variant="outlined"
                  fullWidth
                  value={currentState.panCardNumber}
                  onChange={handleChange}
                />
              </Box>
            </>
          )}

          <Box mb={2}>
            <TextField
              label="Father's Name"
              name="fathersName"
              variant="outlined"
              fullWidth
              value={currentState.fathersName}
              onChange={handleChange}
            />
          </Box>

          <Box mb={2}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                fullWidth
                inputVariant="outlined"
                margin="none"
                id="date-of-birth-picker"
                label="Date Of Birth"
                format="dd/MM/yyyy"
                value={currentState.dateOfBirth || null}
                onChange={(date) => {
                  setCurrentState((prev) => ({
                    ...prev,
                    dateOfBirth: date,
                  }));
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
          </Box>
          <Box mb={2}>
            <TextField
              label="Password - If Blank, then no password is set by client"
              name="kyc_doc_plaintext_password"
              variant="outlined"
              fullWidth
              value={currentState.kyc_doc_plaintext_password}
              onChange={handleChange}
            />
          </Box>

          {!isForm60 && (
            <Box
              mb={2}
              display="flex"
              alignItems="center"
              gap={1}
            >
              <TextField
                label="Date of KRA Validation"
                name="response_date_time"
                variant="outlined"
                fullWidth
                disabled
                value={currentState.response_date_time}
              />

              <IconButton
                onClick={() =>
                  copy(currentState.response_date_time)
                }
              >
                <ContentCopyIcon color="primary" />
              </IconButton>
            </Box>
          )}

          <Box mb={3}>
            <Typography
              variant="subtitle2"
              gutterBottom
            >
              Upload {isForm60 ? "Form 60" : "PAN Card"}
            </Typography>

            <Input
              type="file"
              inputProps={{
                accept: "image/*,.pdf",
              }}
              onChange={(e) =>
                setSelectedFile(e.target.files[0])
              }
              fullWidth
            />
          </Box>

          <Grid container spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={
                  createCond
                    ? addPanCardDetails
                    : savePanCardDetails
                }
                disabled={
                  createCond &&
                  isForm60 &&
                  !selectedFile
                }
              >
                {createCond ? "Create" : "Update"}
              </Button>
            </Grid>

            {!isForm60 && (
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handlePanStatusClick}
                >
                  Pan Status
                </Button>
              </Grid>
            )}

            {!createCond && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    setShowDeleteModal(true)
                  }
                >
                  Delete
                </Button>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Grid>

      {showDeleteModal && (
        <GenericDialog
          show={showDeleteModal}
          heading="Delete Pan Card"
          inputProps="Are you sure you want to delete this pan card ?"
          onClose={() =>
            setShowDeleteModal(false)
          }
          handleSubmit={deletePanCard}
        />
      )}

      {showPanDetailsDialog && (
        <GenericDialog
          show={showPanDetailsDialog}
          heading="PAN Status"
          inputProps={
            <PanCardDetailsModalContent
              panCardDetails={panCardDetails}
            />
          }
          submitButtonText="Close"
          onClose={() => {
            setShowPanDetailsDialog(false);
            setPanCardDetails(null);
          }}
          handleSubmit={() => {
            setShowPanDetailsDialog(false);
            setPanCardDetails(null);
          }}
        />
      )}
    </Grid>
  );
};

export default PanCardInformationGrid;
